import instance from "./instance";

export const validatePromoCode = async (reqData) => {
	try {
		const { data } = await instance.post('/motorRetail/validatePromoCode', reqData)
		if (data) return data
		else Promise.reject({ msg: 'Failed to Apply Promocode' })
	} catch (error) {
		Promise.reject(error)
	}
};




const MotorService = {
	validatePromoCode,
};

export default MotorService;
